// A generic button for the filter bar.
// @flow
import React from 'react';
import Button from 'material-ui/Button';

type Props = {
    children: any,
    onClick: any => any
};

export default ({ children, onClick }: Props) => {
    return (
        <Button
            role="button"
            tabIndex="-1"
            className="filter-bar-button"
            onClick={onClick}
        >
            {children}
        </Button>
    );
};



// WEBPACK FOOTER //
// ./src/view/analytics/FilterBarButton.jsx